import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { BlogPostCategoriesInterface } from 'common/types/entities/BlogPostCategoriesInterface'
import { MasterBlockId } from 'common/types/entities/EntityInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createBlogPostCategories(
  parentId: string,
  masterBlockId?: MasterBlockId,
) {
  return {
    ...generateBaseEntity(
      EntityTypeEnum.BlogPostCategories,
      parentId,
      masterBlockId,
    ),
    type: EntityTypeEnum.BlogPostCategories,
    parentId: parentId,
    fontSize: 12,
    color: 'rgba(0, 116, 199, 1)',
    mobileFontSize: 12,
    alignSelf: 'left',
  } as BlogPostCategoriesInterface
}
